import { keyframes, css } from 'styled-components';
var btnShake = keyframes(["0%{transform:rotate(0);}33%{transform:rotate(30deg);}66%{transform:rotate(-15deg);}100%{transform:rotate(0deg);}"]);
var buttonMotion = {
  shake: css([".ant-btn:not(:disabled):active,.ant-btn:not(:disabled):hover{i{animation:", " 0.5s linear;}}.c7n-btn:not(:disabled),.c7n-pro-btn:not(.c7n-pro-btn-disabled){:hover,:active{i{animation:", " 0.5s linear;}}}"], btnShake, btnShake)
};
export default buttonMotion;